export default "__VITE_ASSET__728b4e30__"